import { React } from '../../../lib';
import { reactFlyout } from '../../component-react';
import { Button } from '../buttons';
import { deleteNotes } from './delete';
import { mergeDocuments } from './merge-notes';
import { EditNoteTagsMulti } from './tags';
export const NoteDetailsMultiSelect = (props) => {
    const { rs, selected } = props;
    return (React.createElement("div", { className: "relative h-full overflow-y-auto bg-neutral-300 text-center" },
        React.createElement("div", { className: "p-3 font-condensed select-none text-center" },
            selected.length,
            " notes selected"),
        React.createElement("div", null,
            React.createElement(Button, { lbl: "Edit Tags", type: "borderless", img: "/static/img/i8/color-edit.svg", onClick: () => {
                    reactFlyout('Edit Note Tags', [360, 360], React.createElement(EditNoteTagsMulti, { rs: rs, selected: selected }));
                } })),
        React.createElement("div", null,
            React.createElement(Button, { lbl: "Delete notes", type: "borderless", img: "/static/img/i8/color-trash-delete.svg", onClick: () => {
                    deleteNotes(rs, selected.map(x => x.ID));
                } })),
        React.createElement("div", null,
            React.createElement(Button, { lbl: "Merge Documents", title: "If the attachment types are supported, this will merge the attachments into a single document on a combined note. You can control the ordering on the confirmation screen", type: "borderless", img: "/static/img/i8/ios16-merge.svg", onClick: () => {
                    mergeDocuments(rs, selected);
                } }))));
};
//# sourceMappingURL=multiple.js.map